import Utils from "./utils";

const Sidebar = {

	init: function() {
		window.lastChange = Date.now();
	  window.scrollCategoryPoint = "";
		let window_width = $(window).width();
		let sidebar = $('#sidebar');
		let content = $('.content-box_products');

		if (sidebar.length > 0 && window_width >= 753 && content.length > 0) {
			$(window).scroll(function () {
				Sidebar.scrolling();
				Sidebar.scrollCheck();
			});
		} else {
			return;
		}

		$(window).resize(function() {
			Sidebar.widthChange();
		});

		if (window_width < 753) {
			Sidebar.toggling();
		}

		Sidebar.animateScroll();
		Sidebar.propFilter();
	},

	//sidebar resizing with window resize
	widthChange: function() {
		let sidebar = $('#sidebar');
		let sidebar_wrapper = $('.sidebar-offcanvas');
		let sidebar_resize_width = sidebar_wrapper.width();

		sidebar.width(sidebar_resize_width);
	},

	// Sidebar behaviour when scrolling, enabled on bigger then small devices
	scrolling: function() {

		//get stuff to lets
		let content = $('.content-box_products');
		if (content.length > 0) {
			let content_height = content.height();
			let content_top = content.offset().top;

			let sidebar_wrapper = $('.sidebar-offcanvas');
			let wrapper_top = sidebar_wrapper.offset().top;

			//set wrapper height according to content height
			sidebar_wrapper.css("height", content_height);

			//get dimensions
			let sidebar = $('#sidebar');
			let sidebar_container_width = sidebar.innerWidth();
			let sidebar_left = sidebar_wrapper.css('padding-left');
			let sidebar_width = sidebar_container_width;
			let sidebar_height = sidebar.height();
			let sidebar_topOffset = sidebar.offset().top;

			let scroll_top = $(window).scrollTop();
			let window_height = $(window).height();
			let header_height = $(".masthead").outerHeight();

			//detect scroll direction
			let direction = Utils.scroll_direction();

			function GimmeDimension() {
				sidebar.css("width", sidebar_width);
				sidebar.css("left", sidebar_left);
			}

			//when the sidebar is taller then window height
			if (sidebar_height > window_height){
				if (direction === "down" && (scroll_top + window_height > sidebar_height + sidebar_topOffset) && (scroll_top + window_height < content_height + content_top)) {
					sidebar.css("position", "fixed");
					sidebar.css("top", "auto");
					sidebar.css("bottom", "0");
					GimmeDimension();
				}
				else if (direction === "down" && (scroll_top + window_height > content_height + content_top)) {
					sidebar.css("position", "absolute");
					sidebar.css("top", "auto");
					sidebar.css("bottom", "20px");
					GimmeDimension();
				}
				else if (direction === "up" && (scroll_top < sidebar_topOffset) && (scroll_top > content_top)){
					sidebar.css("position", "fixed");
					sidebar.css("top", "0");
					sidebar.css("bottom", "auto");
					GimmeDimension();
				}
				else if (direction === "up" && (scroll_top < content_top)) {
					sidebar.css("position", "absolute");
					sidebar.css("top", "0");
					sidebar.css("bottom", "auto");
					GimmeDimension();
				}
				else if (direction === "up" && (scroll_top > content_top) && (scroll_top < (content_top + content_height - sidebar_height))) {
					sidebar.css("position", "fixed");
					sidebar.css("top", "0");
					sidebar.css("bottom", "auto");
					GimmeDimension();
				}
				else if (direction === "down" && (scroll_top > content_top) && (scroll_top < (content_top + content_height - sidebar_height))) {
					sidebar.css("position", "fixed");
					sidebar.css("top", "auto");
					sidebar.css("bottom", "0");
					GimmeDimension();
				}
			}
			// when the sidebar is shorter then window height
			else {
				if (scroll_top >= wrapper_top && (scroll_top + window_height) < content_height) {
					sidebar.css("position", "fixed");
					sidebar.css("top", "0");
					GimmeDimension();
				} else if (scroll_top < wrapper_top && scroll_top < (content_height - sidebar_height) && direction == "up") {
					sidebar.css("position", "absolute");
					sidebar.css("top", "0");
					GimmeDimension();
				} else if ((scroll_top + sidebar_height) > (content_height + content_top) && direction == "down") {
					sidebar.css("position", "absolute");
					sidebar.css("top", "auto");
					sidebar.css("bottom", "0");
					GimmeDimension();
				} else if (direction == "up" && scroll_top <= (header_height + content_height - sidebar_height)) {
					sidebar.css("position", "fixed");
					sidebar.css("top", "0");
					GimmeDimension();
				}
			}
		}
	},

	// Enabled just on small devices, just toggling menu
	toggling: function(){
		let toggler = $('#sidebar-toggler');
		let sidebar = $('#sidebar');

		toggler.on("click", function(){
			sidebar.toggle();
		});
	},

	// Animate scroll to item after click on menu items href
	animateScroll: function () {
		$('.js-list-group-item').on('click', function(event) {

			let target = $( $(this).attr('href') );

			if( target.length ) {
				window.scrollCategoryPoint = $(this).attr('href').replace("#", '');
				event.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top + 1
				}, 1000);
			}
		});
	},

	// Highlight scrolled category in menu
	scrollCheck: function () {

		if ($('.product-menu-link').length) {
			// All list items
			let menuItems = $('.product-menu-link'),
				headlineItems = $('.js-headline-item'),

				// Anchors corresponding to menu items
				scrollItems = menuItems.map(function(){
					let item = $($(this).attr("href"));
					if (item.length) {
						return item;
					}
				});

			// Anchors corresponding to categories titles
			let scrollTitles = headlineItems.map(function(){
				let item = $($(this).attr("data-anchor"));
				if (item.length) {
					return item;
				}
			});

			// Get container scroll position
			let fromTop = $(window).scrollTop();

			// Get id of current scroll item
			let cur = scrollItems.map(function(){
				if ($(this).offset().top < fromTop)
					return this;
			});

			// Get the id of the current element
			cur = cur[cur.length-1];
			let id = cur && cur.length ? cur[0].id : "";

			if (window.lastId !== id) {
				window.lastId = id;
				// Set/remove active class
				menuItems
					.parent().removeClass("active")
					.end().filter("[href='#"+id+"']").parent().addClass("active");

				headlineItems
					.parent().removeClass("active")
					.end().filter("[data-anchor='"+id+"']").parent().addClass("active");

				if (window.scrollCategoryPoint.length) {
					if (id === window.scrollCategoryPoint) {
						window.scrollCategoryPoint = "";
						ga('send', 'pageview', location.pathname + "#" + id);
					}
				} else if (Date.now() > window.lastChange + 2000 && id.length) {
					ga('send', 'pageview', location.pathname + "#" + id);
					window.lastChange = Date.now();
				}
			}

			let top_nav = document.getElementById("scrolling-top_navigation");
			if ($('.headline-box').hasClass("active")) {
				top_nav.style.display = 'block'
			} else {
				top_nav.style.display = 'none'
			}
		}

	},

	propFilter: function () {

		// here will be code for filtering

	}
};

export default Sidebar;
